import { render } from "./PveMain.vue?vue&type=template&id=6312bb2e&scoped=true"
import script from "./PveMain.vue?vue&type=script&lang=js"
export * from "./PveMain.vue?vue&type=script&lang=js"

import "./PveMain.vue?vue&type=style&index=0&id=6312bb2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6312bb2e"]])

export default __exports__